import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ApiClient } from '../common/api-client.service';
import { SessionUserData } from '../common/session.service';

interface User {
  current_password: string;
  password: string;
  password_confirmation: string;
}

@Component({
  templateUrl: './password.component.html'
})
export class PasswordSettingsComponent {
  user: User = {current_password: null, password: null, password_confirmation: null};

  constructor(
    private apiClient: ApiClient,
    private router: Router,
  ) {}

  save() {
    this.apiClient.patch<SessionUserData>('/api/v1/user', this.user).toPromise().then(user => {
      this.router.navigateByUrl('/account')
    }, resp => {
      this.user.current_password = null;
      // TODO
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/settings/password.component.ts